"use strict";
import('./bootstrap').catch((error)=>console.error(error)); //# sourceMappingURL=main.js.map
